module.exports = __webpack_public_path__ + "static/media/Nico_Luce.dfcad7e1.jpg";